import { useQuery } from '@tanstack/react-query';
import { attachments } from '@lingaai/supabase-client';

export interface AttachmentFile {
  name: string;
  size: number;
  mimeType: string;
  url: string;
}

export function useAttachments(nodeId: string) {
  return useQuery({
    queryKey: ['attachments', nodeId],
    queryFn: () => attachments.getAttachments(nodeId),
    enabled: !!nodeId,
  });
}
